import { Component } from '@angular/core';
import { AlertComponent } from '@shared/components/alert/alert.component';
import { Modal } from '@app/core/types/modal-type';

@Component({
  selector: 'app-default-modal',
  imports: [
    AlertComponent
  ],
  templateUrl: './default-modal.component.html',
  styleUrl: './default-modal.component.css'
})
export class DefaultModalComponent implements Modal {

  public submit(): void {
    console.warn('No modal has been defined in the config.');
  }

}
